import React from 'react';
import { Button, Spinner } from 'react-bootstrap';

const CustomButton = ({ 
  isLoading, 
  label, 
  loadingLabel = "Caricamento...", 
  icon, 
  onClick, 
  disabled = false,
  variant = "primary",
  className = "",
  ...props 
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={isLoading || disabled}
      variant={variant}
      className={className}
      {...props}
    >
      {isLoading ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          {loadingLabel}
        </>
      ) : (
        <>
          {icon && <i className={`bi ${icon} me-2`}></i>}
          {label}
        </>
      )}
    </Button>
  );
};

export default CustomButton;